import { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import CardItem from "./CardItem";
import DiscountService from "../../../services/DiscountService";
import { Translate } from "../../Enums/Tranlate";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import Pagination from "../../common/Pagination/Pagination";
import AddDiscountModal from "./AddDiscountModal";

const Discount = () => {
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const [addModal, setAddModal] = useState(false);
	const [item, setItem] = useState({});
	const discountService = new DiscountService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const search = useSelector((state) => state.auth.search);

	return (
		<div className="admin">
			<div className="mb-3">
				<div className="d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].discount}
						</span>
					</div>
					<div className="add-admin">
						{/* {isExist("add_discount") && ( */}
						<Button
							variant="primary"
							className="me-2 h-75"
							onClick={() => {
								setItem({});
								setAddModal(true);
							}}>
							<i
								className={`la la-plus ${lang === "en" ? "mr-2" : "ml-2"}`}></i>
							{Translate[lang]?.add} {Translate[lang]?.discount}
						</Button>
						{/* )} */}
					</div>
				</div>
			</div>

			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									<th>
										<strong>{Translate[lang]?.name}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.code}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.price}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.type}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.vendor}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.action}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.length > 0 &&
									data?.map((item, index) => {
										return (
											<CardItem
												key={index}
												index={index}
												item={item}
												setAddModal={setAddModal}
												setItem={setItem}
												setShouldUpdate={setShouldUpdate}
											/>
										);
									})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setData}
						service={discountService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
					/>
				</div>
			</div>
			{addModal && (
				<AddDiscountModal
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
					item={item}
				/>
			)}
		</div>
	);
};
export default Discount;
